var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"autoCompleteListItem",class:{ selected: _vm.selected },on:{"click":_vm.onItemClick}},[_vm._v("\n  "+_vm._s(_vm._f("locationName")(_vm.item.description))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }